export default "__VITE_ASSET__HBmA5UMl__"